import { render } from "./ScoreHBHzb.vue?vue&type=template&id=e99286ea&scoped=true"
import script from "./ScoreHBHzb.vue?vue&type=script&lang=js"
export * from "./ScoreHBHzb.vue?vue&type=script&lang=js"

import "./ScoreHBHzb.vue?vue&type=style&index=0&id=e99286ea&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99286ea"]])

export default __exports__